import { IRootState } from '@/types/rootState';

export const state = () =>
    ({
        version: '1.0.0',
    } as IRootState);
